import { render, staticRenderFns } from "./baseNavTab.vue?vue&type=template&id=4ed735dc&scoped=true&"
import script from "./baseNavTab.vue?vue&type=script&lang=js&"
export * from "./baseNavTab.vue?vue&type=script&lang=js&"
import style0 from "./baseNavTab.vue?vue&type=style&index=0&id=4ed735dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed735dc",
  null
  
)

export default component.exports